import { render } from "./SectionsTagsSlider.vue?vue&type=template&id=706f6a1e&scoped=true"
import script from "./SectionsTagsSlider.vue?vue&type=script&lang=js"
export * from "./SectionsTagsSlider.vue?vue&type=script&lang=js"

import "./SectionsTagsSlider.vue?vue&type=style&index=0&id=706f6a1e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-706f6a1e"]])

export default __exports__